import { MsalInstance } from "./msalHelper";
import { localeQueryParameters } from "./../authConfig";

// Punto único de salida. Los dos llamadores (menú de usuario y sesión expirada) deben
// comportarse igual en los dos tenants.
//
// Importante: no pasar `postLogoutRedirectUri` acá. El valor sale de msalConfig y
// tanto Azure AD B2C como Entra External ID validan que coincida con un redirect URI
// registrado en la app registration. Los dos llamadores lo pasaban mal: uno vacío, que
// hace que MSAL omita el parámetro, y el otro leyendo `msalConfig.postLogoutRedirectUri`,
// que no existe en ese nivel del objeto y siempre valía `undefined`.
export default function signOut(account) {
    const msalInstance = MsalInstance.getCurrentInstance();

    // El idioma se fuerza también acá: la pantalla de cierre de sesión la sirve el mismo
    // IdP y sin `ui_locales` sale en inglés por el mismo motivo que el login (authConfig.js).
    return msalInstance.logoutRedirect({
        account: account ?? msalInstance.getAllAccounts()[0] ?? null,
        extraQueryParameters: localeQueryParameters
    });
}
